import { createContext, PropsWithChildren, useContext, useState } from 'react';

type ColorScheme = 'dark' | 'light';

const ColorSchemeContext = createContext(
  {} as {
    colorScheme: ColorScheme;
    setColorScheme: (colorScheme: ColorScheme) => void;
  },
);

const ColorSchemeProvider: React.FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [colorScheme, _setColorScheme] = useState<ColorScheme>(
    () => (localStorage.getItem('app-theme') as ColorScheme) || 'light',
  );

  function setColorScheme(newColorScheme: ColorScheme) {
    localStorage.setItem('app-theme', newColorScheme);
    _setColorScheme(newColorScheme);
  }

  return (
    <ColorSchemeContext.Provider value={{ colorScheme, setColorScheme }}>
      {children}
    </ColorSchemeContext.Provider>
  );
};

export function useColorScheme(): [
  ColorScheme,
  (colorScheme: ColorScheme) => void,
] {
  const { colorScheme, setColorScheme } = useContext(ColorSchemeContext);
  return [colorScheme, setColorScheme];
}

export default ColorSchemeProvider;
